import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/custom/components/organisms/User/FieldView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })
    const history = useHistory()

    const { user_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 1,
        emp_type: 'seller',
        probation: 1,
    }

    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setManage({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                user_type: 0,
                // secondaryID: props?.match?.params?.sid,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            let dynamicValueAssign = []
            user_dynamicfields.forEach((item) => {
                // Check if item should be pushed based on 'view_on' condition
                if (item.view_on && item.view_on.includes('4')) {
                    dynamicValueAssign.push(item)
                } else if (!item.view_on) {
                    dynamicValueAssign.push(item)
                }

                // Check for 'zip' and assign 'text' type
                if (item.name === 'zip') {
                    item.type = 'text'
                }
                // if (item.name === 'user_restrict') {
                //     item.label = 'Seller Access Restricted'
                // }
            })

            // Add default value for 'market_status'
            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })

            // Filter out items based on specific conditions
            if (props?.match?.params?.status == 'new') {
                const temp = dynamicValueAssign.filter((item) => {
                    return (
                        item.name !== 'password' &&
                        item.name !== 'confirm_password' &&
                        item.name !== 'phone' &&
                        item.name !== 'reenter_email_address' &&
                        item.name !== 'mobile_number' &&
                        item.name !== 'user_restrict' &&
                        item.name !== 'seller_restrict' &&
                        item.name !== 'companyname' &&
                        item.name !== 'search_default' &&
                        item.for_organization === 1
                    )
                })

                // Set the field values for the component
                setFieldValue(temp)
            } else {
                const temp = dynamicValueAssign.filter((item) => {
                    return (
                        item.name !== 'password' &&
                        item.name !== 'confirm_password' &&
                        item.name !== 'phone' &&
                        item.name !== 'reenter_email_address' &&
                        item.name !== 'mobile_number' &&
                        item.name !== 'companyname' &&
                        item.name !== 'user_restrict' &&
                        item.name !== 'search_default' &&
                        item.for_organization === 1
                    )
                })

                // Set the field values for the component
                setFieldValue(temp)
            }
        }
    }, [user_dynamicfields, props?.match?.params?.status])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }

    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    customInitial={customInitial}
                    data={manage}
                    function={closeFunction}
                    additionalFieldUpdate={additionalFieldUpdate}
                    seller={true}
                    standalone={true}
                    changePassword={true}
                    empPassword={false}
                />
            </Layout>
        </>
    )
}

export default UserCommon
